export default __webpack_public_path__ + "static/poster_02-9cf49876724fdf2153a27f8a150a204b.png";